const API_BASE     = import.meta.env.VITE_API_BASE_URL;
const FUNCTION_KEY = import.meta.env.VITE_FUNCTION_KEY;

// Returns { [userId]: azureBlobUrl } for all pre-cached photos.
// Manifest is unauthenticated — blobs are already publicly accessible.
export async function getPhotoManifest() {
  if (!API_BASE) return {};
  try {
    const res = await fetch(`${API_BASE}/photos/manifest`);
    if (!res.ok) return {};
    return await res.json();
  } catch {
    return {};
  }
}

// Lazy write-back: contribute a photo pulled from Graph to the shared cache so
// the next viewer gets it instantly from Blob Storage. Fire-and-forget — never
// block the UI and never throw. The backend writes only if the user isn't
// already cached, so this is safe to call for every Graph-sourced photo.
export async function cachePhoto(apiToken, userId, blob) {
  if (!API_BASE || !apiToken || !blob) return;
  try {
    await fetch(`${API_BASE}/photos/cache/${userId}`, {
      method: 'POST',
      headers: {
        'Content-Type': blob.type || 'image/jpeg',
        Authorization: `Bearer ${apiToken}`,
      },
      body: blob,
    });
  } catch { /* best-effort cache warming; ignore failures */ }
}

export { FUNCTION_KEY };
